module.exports = __webpack_public_path__ + "img/image-spaceport-landscape.28a920cf.jpg";